import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../../elements/Button';
import Popup from '../../Popup';
import { useClosePopup } from '../../../utils/hooks/usePopup';
import { UseInvoiceInvoice } from 'src/utils/api/Invoices';

export default function AddPayment({ invoice }: {invoice: UseInvoiceInvoice}) {

	// Payment method state, default value 'none'.
	const [paymentMethod, setPaymentMethod] = useState('none');
	const [amount, setAmount] = useState(invoice.leftToPay);


	const close = useClosePopup();

	const addPayment = async () => {
		if (paymentMethod === 'none') {
			alert('Välj betalningsmetod');
			return;
		}

		try {
			await invoice.makePayment(amount, paymentMethod as any);

		} catch (e) {
			alert('Något gick fel');
			console.error(e);
		}

		close();
	};

	return (
		<Popup close={close} width="40em" maxWidth="30em">
			<Style>
				<h2 className="title">Lägg till betalning</h2>
				<div className="spacer s"></div>
				<p>
					Du kommer skapa en betalning för denna faktura. Om fakturan blir helt betald genom denna betalning så kommer ett kvitto automatiskt att skickas till kunden.
				</p>

				<div className="spacer s"></div>

				<label>Summa betalat</label><br/>
				<input type="number" onChange={e => setAmount(Number(e.target.value))} value={amount} />

				<div className="spacer s"></div>

				{/* Payment method select input attached to the state. */}
				<label>Betalmetod</label><br/>
				<select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
					<option value="none" disabled>
						Välj betalmetod...
					</option>
					<option value="onsite_card">På plats - Kort</option>
					<option value="onsite_cash">På plats - Kontant</option>
					<option value="onsite_swish">På plats - Swish</option>
					<option value="invoice_bank">Faktura - Inbetalning Bank</option>
					<option value="invoice_swish">Faktura - Swish</option>
				</select>

				<div className="spacer m"></div>

				<div className="spacer m"></div>

				<div className="buttons">
					<Button type="secondary" onClick={close}>
						Nej
					</Button>
					<Button onClick={addPayment}>Ja</Button>
				</div>
			</Style>
		</Popup>
	);
}

const Style = styled.div``;
